import Footer from "./Footer";
import Header from "./Header";

const TermsAndConditions = () => {
  return (
    <>
      <Header />

      <section className="bg-white py-5">
        <div className="container">
          <h1 className="display-6 text-dark">Terms & Conditions</h1>

          <section>
            <h3 className="text-dark">1. Introduction</h3>
            <p>
              Welcome to <u>Visualaey</u>, a next-generation, AI-powered event
              photo-sharing platform. By accessing or using our platform, you
              agree to comply with and be bound by these Terms & Conditions.
              Please read them carefully before using our services.
            </p>
          </section>

          <section>
            <h3 className="text-dark">2. Services Provided</h3>
            <p>
              Visualaey provides users with a secure, cloud-native platform to
              discover and share event photos seamlessly. Our services include:
            </p>
            <ul>
              <li>
                AI-powered facial recognition to match guests with photos
                instantly.
              </li>
              <li>Cloud storage and secure access to shared memories.</li>
              <li>Event-specific galleries accessible to registered guests.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">3. User Responsibilities</h3>
            <p>By using Visualaey, you agree to:</p>
            <ul>
              <li>Provide accurate and complete registration information.</li>
              <li>Maintain the confidentiality of your login credentials.</li>
              <li>Respect the privacy and rights of other users.</li>
              <li>Use the platform for lawful purposes only.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-dark">4. Privacy and Data Security</h3>
            <p>
              We take data security seriously. Visualaey employs advanced
              encryption and secure cloud infrastructure to protect user data.
              Facial recognition data is used solely to enhance your experience
              and is never sold to third parties.
            </p>
          </section>

          <section>
            <h3 className="text-dark">5. Payments and Razorpay Integration</h3>
            <p>
              Visualaey integrates with Razorpay for payment processing. By
              using our paid services:
            </p>
            <ul>
              <li>You agree to the terms and privacy policy of Razorpay.</li>
              <li>
                All transactions are securely processed through Razorpay’s
                gateway.
              </li>
              <li>
                Visualaey is not responsible for any payment disputes; contact
                Razorpay support for assistance.
              </li>
            </ul>
            <p>
              <strong>Note:</strong> Payment confirmation is required to access
              certain premium features of Visualaey.
            </p>
          </section>

          <section>
            <h3 className="text-dark">6. Intellectual Property</h3>
            <p>
              All content, including images, logos, and software on Visualaey,
              is the property of Visualaey or its licensors. Unauthorized
              copying, distribution, or reproduction of any material is strictly
              prohibited.
            </p>
          </section>

          <section>
            <h3 className="text-dark">7. Limitation of Liability</h3>
            <p>
              Visualaey is provided "as is" without warranties of any kind. We
              do not guarantee uninterrupted service or complete accuracy of
              facial recognition. Users agree that Visualaey shall not be liable
              for any direct, indirect, incidental, or consequential damages.
            </p>
          </section>

          <section>
            <h3 className="text-dark">8. Termination</h3>
            <p>
              Visualaey reserves the right to suspend or terminate your account
              at any time for violations of these Terms & Conditions, misuse of
              the platform, or unlawful activities.
            </p>
          </section>

          <section>
            <h3 className="text-dark">9. Governing Law</h3>
            <p>
              These Terms & Conditions are governed by and construed in
              accordance with the laws of the jurisdiction in which Visualaey
              operates. Any disputes will be subject to the exclusive
              jurisdiction of the courts in that jurisdiction.
            </p>
          </section>

          <section>
            <h3 className="text-dark">10. Changes to Terms</h3>
            <p>
              Visualaey may update these Terms & Conditions from time to time.
              Users will be notified of significant changes via email or
              platform notifications. Continued use of the platform after
              changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h3 className="text-dark">11. Contact Us</h3>
            <p>
              For any questions regarding these Terms & Conditions, please
              contact our support team at{" "}
              <a href="mailto:support@visualaey.com">support@visualaey.com</a>.
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default TermsAndConditions;
